<div class="box">
    <div class="box-title">
        {{ 'LastFeedback' | translate }}

        <button mat-mini-fab
                color="none"
                class="more-button float-right"
                [matTooltip]="'FeedbackAll' | translate"
                [routerLink]="'/' + organization?.code + '/athletes/' + athleteUser?.id + '/feedback'"
        >
            <mat-icon color="primary">zoom_in</mat-icon>
        </button>
    </div>
    <div class="box-content">
        <mat-spinner *ngIf="isLoading; else boxContent" [diameter]="30"></mat-spinner>
    </div>
</div>

<ng-template #boxContent>
    <div *ngIf="latestFeedbackData.length > 0">
        <span class="last-feedback-date">{{ latestFeedbackData[0].answeredAt | date }}</span>

        <mat-list-item *ngFor="let data of latestFeedbackData">
            <h4 mat-line>{{ data.questionTitle }}</h4>
            <p mat-line>{{ data.answerLabel || data.answerUserData }} </p>
        </mat-list-item>
    </div>
    <div *ngIf="latestFeedbackData.length == 0">
        <p>{{ 'NoFeedbackAtTheMoment'|translate }}</p>
    </div>
</ng-template>
